<script>

    import { toast } from 'bulma-toast'
    import { notificationStore, notificationsStore, modalStore } from '../stores'

    import NotificationsService from '../$services/notifications.service.js'
    import DateMethod from '../$methods/date.method'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import Button from '../$components/button.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false

    async function deleteNotification() {

        loading = true
        const resp = await NotificationsService.deleteNotification($notificationStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.remove($notificationStore._id)

        toast({message: 'Notificación borrada', type: 'is-success'})

        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard title={$notificationStore.subject} meta="Notificación global">
        <DetailsFields>
            <DetailsField label="Mensaje" value={$notificationStore.message} />
            <DetailsField label="¿Urgente?" value={ String($notificationStore.important) } />
            <DetailsField label="Creación" value={DateMethod.dateTimeLarge($notificationStore.created)} />
            <DetailsField label="Expiración" value={DateMethod.dateTimeLarge($notificationStore.expired)} />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
                    <ButtonModal modalId="notification_update_modal" icon="edit" text="Actualizar" />
                    <ButtonDelete on:confirm={deleteNotification} {loading} />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
